<div class="icon" [ngClass]="icon"></div>
